import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/query-client';
import { AuthProvider } from './contexts/AuthContext';
import { CommuneProvider } from './contexts/CommuneContext';
import { ImpersonationProvider } from './contexts/ImpersonationContext';
import { router } from './router';
import { ErrorToast } from './components/ui/ErrorToast';
export default function App() {
    return (_jsx(QueryClientProvider, { client: queryClient, children: _jsx(AuthProvider, { children: _jsx(ImpersonationProvider, { children: _jsxs(CommuneProvider, { children: [_jsx(RouterProvider, { router: router }), _jsx(ErrorToast, {})] }) }) }) }));
}
